/**
 * Utility functions for table management.
 * Provides helper functions for calculating widths and column ordering.
 */

/**
 * Calculate total table width from visible columns.
 *
 * @param visibleColumns Array of visible column keys
 * @param getColumnWidth Function to get width of a column
 * @returns Total width in pixels
 *
 * @example
 * const width = calculateTableWidth(visibleColumns, tablePrefs.getColumnWidth);
 */
export const calculateTableWidth = (
  visibleColumns: string[],
  getColumnWidth: (key: string) => number
): number => {
  return visibleColumns.reduce((total, columnKey) => {
    return total + getColumnWidth(columnKey);
  }, 0);
};

/**
 * Get visible columns in correct order.
 *
 * @param columnOrder Ordered list of all column keys
 * @param visibleColumns List of visible column keys
 * @returns Ordered list of visible column keys
 *
 * @example
 * const ordered = getOrderedVisibleColumns(columnOrder, visibleColumns);
 */
export const getOrderedVisibleColumns = (
  columnOrder: string[],
  visibleColumns: string[]
): string[] => {
  return columnOrder.filter((key) => visibleColumns.includes(key));
};
